var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgS = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 29,
    rx: 3.5,
    stroke: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.521,
    y: 2.559,
    width: 22.959,
    height: 23.346,
    rx: 1.75,
    stroke: "#fff",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.064 18.084c-.584 0-1.112-.1-1.584-.3a2.597 2.597 0 0 1-1.104-.864c-.272-.376-.412-.82-.42-1.332h1.8c.024.344.144.616.36.816.224.2.528.3.912.3.392 0 .7-.092.924-.276a.935.935 0 0 0 .336-.744.853.853 0 0 0-.228-.612 1.527 1.527 0 0 0-.576-.372 7.887 7.887 0 0 0-.936-.312c-.544-.16-.988-.316-1.332-.468a2.469 2.469 0 0 1-.876-.708c-.24-.32-.36-.744-.36-1.272 0-.496.124-.928.372-1.296a2.328 2.328 0 0 1 1.044-.84c.448-.2.96-.3 1.536-.3.864 0 1.564.212 2.1.636.544.416.844 1 .9 1.752h-1.848a.935.935 0 0 0-.372-.708c-.224-.192-.524-.288-.9-.288-.328 0-.592.084-.792.252-.192.168-.288.412-.288.732 0 .224.072.412.216.564.152.144.336.264.552.36.224.088.536.192.936.312.544.16.988.32 1.332.48.344.16.64.4.888.72.248.32.372.74.372 1.26 0 .448-.116.864-.348 1.248-.232.384-.572.692-1.02.924-.448.224-.98.336-1.596.336Z",
    fill: "#fff"
  })));
};
export { SvgS as ReactComponent };